(() => {
    const initAccordions = () => {
        const scope = document.querySelector("main") || document;
        scope.addEventListener("toggle", (event) => {
            const details = event.target;
            if (!(details instanceof HTMLDetailsElement) || !details.open || !details.closest(".product-section, .product-section-tabs")) return;
            scope.querySelectorAll(".product-section details[open], .product-section-tabs details[open]").forEach((item) => {
                if (item !== details) item.open = false;
            });
            scope.querySelectorAll('.product-section-tabs .collapsed-inner > input[id^="tab-"]:checked').forEach((input) => {
                input.checked = false;
                input.dispatchEvent(new Event("change", { bubbles: true }));
            });
        }, true);
    };

    document.addEventListener("DOMContentLoaded", () => {
        initAccordions();
    });
})();
